// extracted by mini-css-extract-plugin
export default {"root":"styles_root__SmOgo","label":"styles_label__R2Sv3","selected":"styles_selected__nYIMF"};